<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { Input } from "@infinitro/input";
import { applyIdentifierInput, stateIdentifier, submit } from "../state";
import { isValidLoginIdentifier } from "../utils/passwordCredentials";
let element = null;
let valid = false;
let autofillLocked = true;
$: useFlat = $stateUi.modal?.modalStyle === "flat";
const unlockAutofill = () => {
	autofillLocked = false;
};
const onInput = (value) => {
	valid = isValidLoginIdentifier(value);
	applyIdentifierInput(value);
};
const onKeydown = (event) => {
	if (event.key !== "Enter") return;
	event.preventDefault();
	submit(event);
};
</script>

<label class="field" class:field-flat={useFlat} for="loginIdentifier">
	<span class="label">{$t(Verbiage.username_or_email)} *</span>
	<Input
		type="text"
		name="login-identifier"
		id="loginIdentifier"
		autocomplete="off"
		readonly={autofillLocked}
		onFocus={unlockAutofill}
		placeholder={$t(Verbiage.enter_your_username_or_email)}
		required
		bind:element
		bind:value={$stateIdentifier}
		{onInput}
		{onKeydown}
		customBorderRadius={useFlat ? '8px' : undefined}
		inputClasses={useFlat ? 'auth-flat-input-el' : ''}
		error={Boolean($stateIdentifier) && !valid}
	/>
</label>

<style>
	.field {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0.5rem
}
	.field-flat {
    padding-top: 0px;
    padding-bottom: 0px
}
	.label {
    margin-top: 0.5rem;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
</style>
